import { FC } from 'react';
import * as React from 'react';
import Script from 'next/script';
import { withOptimizely, WithOptimizelyProps } from '@optimizely/react-sdk';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';
import { Header as DefaultHeader } from '@zoopla/header';
import { useRouter } from 'next/router';

const Header: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);
    const { asPath } = useRouter();

    return (
        <>
            {_useLiveRamp && (
                <Script
                    src={process.env.NEXT_PUBLIC_LIVERAMP_CMP_SCRIPT_URL}
                    strategy="beforeInteractive"
                />
            )}
            <DefaultHeader path={asPath} />
        </>
    );
};

export default withOptimizely(Header);
